(function() {
    $('.slug-input').on('change', function() {
        var $field = $(this)
        var formattedValue = $field.val()
            .toLowerCase()
            .replace(/[^\w- ]+/g, '')
            .trim()
            .replace(/ +/g, '-')

        $field.val(formattedValue)

        $('.slug-input').data('auto', false);
    });
    $('.slug-control').blur(function() {
    	if($('.slug-input').val() == "" || $('.slug-input').data('auto')){
	    	var $field = $(this)
	        var formattedValue = $field.val()
	            .toLowerCase()
	            .replace(/[^\w- ]+/g, '')
	            .trim()
	            .replace(/ +/g, '-')
	        $('.slug-input').data('auto', true);
	        $('.slug-input').val(formattedValue);

    	}
    });
})()
